import { useEffect, useState } from "react";
import { Spacings, View } from "react-native-ui-lib";
import {
  GlobalSettingsContext,
  UseGlobalSettingsContext,
} from "../../utilities/global-settings/context";
import { useGlobalSettings } from "../../utilities/global-settings/hooks";
import { useAuthenticationProvider } from "@towersystems/roam-common-native/lib/utilities/authentication";
import {
  Page,
  Stack,
  TextButton,
  VStack,
  Button,
  Text,
} from "@towersystems/roam-common-native";
import { AnimatedDots } from "../AnimatedDots";

export interface GlobalSettingsControllerProps {
  children?: React.ReactNode;
}

export const GlobalSettingsController = ({
  children,
}: GlobalSettingsControllerProps) => {
  const [error, setError] = useState(false);
  const useGlobalSettingsRepsonse = useGlobalSettings();
  const { globalSettings, queryGlobalSettings } = useGlobalSettingsRepsonse;
  const { isLoggedIn, logout } = useAuthenticationProvider();

  const handleQueryGlobalSettings = async () => {
    setError(false);
    queryGlobalSettings().catch((e) => {
      setError(true);
    });
  };

  useEffect(() => {
    handleQueryGlobalSettings();
  }, []);

  const isLoggedInMarkup = isLoggedIn && (
    <View
      style={{
        position: "absolute",
        bottom: Spacings.s4,
        left: Spacings.s4,
        right: Spacings.s4,
        alignItems: "center",
      }}
    >
      <TextButton
        onPress={() => {
          logout();
        }}
        color="subdued"
      >
        Cancel and logout
      </TextButton>
    </View>
  );

  if (error) {
    return (
      <Page fullWidth scrollable={false}>
        <VStack
          spacing={Spacings.s2}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <View
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Text variant="heading">Whoops Global!...</Text>
            <Text variant="heading3">Something went wrong</Text>
            <Text variant="caption" style={{ marginTop: Spacings.s2 }}>
              Refresh page to try again, or reset local data.
            </Text>
          </View>
          <View
            style={{
              marginTop: Spacings.s4,
            }}
          >
            <Stack>
              <Button
                label="Try Again"
                isAction
                onPress={handleQueryGlobalSettings}
              ></Button>
            </Stack>
          </View>
        </VStack>
        {isLoggedInMarkup}
      </Page>
    );
  }

  if (!globalSettings) {
    return (
      <Page fullWidth scrollable={false}>
        <VStack
          spacing={Spacings.s2}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <AnimatedDots text="Loading Settings" />
        </VStack>
        {isLoggedInMarkup}
      </Page>
    );
  }

  const content = globalSettings ? (
    <GlobalSettingsContext.Provider value={globalSettings}>
      {!globalSettings.cashManagedPaymentMethodId && (
        <View style={{ alignItems: "center", padding: 10 }}>
          <Text>NO CASH MANAGED PAYMENT METHOD FOUND</Text>
          <Text>
            You will not be able to process payments that give change.
          </Text>
        </View>
      )}
      {children}
    </GlobalSettingsContext.Provider>
  ) : null;

  return (
    <UseGlobalSettingsContext.Provider value={useGlobalSettingsRepsonse}>
      {content}
    </UseGlobalSettingsContext.Provider>
  );
};
